import { UserNotificationPreferences } from '@app/domain/UserNotificationPreferences'
import { Venue } from '@app/domain/Venue'

export class BaseUser {
    constructor(
        public id: string,
        public name: string,
        public venueIds: string[] | null,
        public notificationPreferences: UserNotificationPreferences[],
        public pinCode: string | null
    ) { }

    worksInVenue(venue: Venue): boolean {
        if (this.venueIds === null) {
            return true
        }
        return this.venueIds.includes(venue.id)
    }
}
